import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

export namespace ConnectedApplicationsDetailsPageStyles {

// we use cssClass to make inspection easier; see discussion
// https://tableau.slack.com/archives/C9H9ERB5G/p1567531204044200?thread_ts=1567122602.032800&cid=C9H9ERB5G
const cssPrefix = 'connected-application';

export const backButtonSectionStyle = cssClass(cssPrefix, 'back-section', {
  display: 'flex',
  paddingLeft: 20,
  paddingTop: 15,
  alignItems: 'center',
});

export const connectedApplicationHeaderTestId = 'header';

export const headerStyle = cssClass(cssPrefix, 'header', {
  fontSize: TabStyles.Typography.Sizing.XXLarge,
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey51,
  paddingLeft: 20,
  paddingTop: 5,
  display: 'flex',
  flexDirection: 'row',
});

export const connectedApplicationSubHeaderTestId = 'sub-header';

export const subHeaderStyle = cssClass(cssPrefix, 'sub-header', {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey51,
  paddingLeft: 20,
  paddingTop: 5,
});

export const bodyStyle = cssClass(cssPrefix, 'body', {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey51,
  paddingLeft: 30,
  paddingTop: 10,
});

export const connectedApplicationSecretDetailsTestId = 'secret-details';
export const connectedApplicationClientIdDetailsTestId = 'client-id-details';
export const connectedApplicationSiteLuidTestId = 'site-luid';
export const connectedApplicationAccessDetailsTestId = 'access-details';
export const connectedApplicationDomainsDetailsTestId = 'domains-details';
export const connectedApplicationEasIssuerURLDetailsTestId = 'issuer-url';
export const connectedApplicationEasJWKSURIDetailsTestId = 'jwks-uri';

// rowStyle, labelStyle, detailsStyle, detailsBorderStyle, detailsStyleWithNoBorder, detailsStyleWithBorder, buttonCellStyleWithBorder, tableStyle
// all adapted from src\schedule\components\ScheduleDetailsSubspace.tsx
export const tableStyle = cssClass(cssPrefix, 'table', {
  maxWidth: '768px',
  paddingRight: '18px',
  marginTop: '12px',
  maxHeight: '300px',
  display: 'block',
});

const rowStyle = {
  padding: '12px',
};

export const labelStyle = cssClass(cssPrefix, 'label', {
  width: '1%',
  paddingLeft: '18px',
  textAlign: 'right',
  fontSize: '15px',
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey153,
  lineHeight: '23px',
  whiteSpace: 'nowrap',
}, rowStyle);

const detailsStyle = {
  width: 500,
  paddingTop: '15px',
  lineHeight: '1.35em',
};

const detailsBorderStyle = {
  borderBottom: `1px solid ${TabStyles.Colors.F7Disabled}`,
};

export const detailsStyleWithBorder = cssClass(cssPrefix, 'details-border', rowStyle, detailsStyle, detailsBorderStyle, {
  whiteSpace: 'pre-line',
});

export const secretsCell = cssClass(cssPrefix, 'details-secrets-cell', rowStyle, detailsStyle, detailsBorderStyle, {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 40, // Without this the details cell ends up smaller than the label and the divider ends up in the wrong place
});

export const secretsCellLastRow = cssClass(cssPrefix, 'details-secrets-cell-last-row', detailsStyle, {
  display: 'flex',
  alignItems: 'end',
  flexDirection: 'row-reverse',
  justifyContent: 'space-between'
});

export const cellDescriptionSubtextStyle = cssClass(cssPrefix, 'description-subtext', {
  fontSize: TabStyles.Typography.Sizing.Small,
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey178
});

export const clientIdCell = cssClass(cssPrefix, 'details-client-cell', rowStyle, detailsStyle, detailsBorderStyle, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const easDetailsCell = cssClass(cssPrefix, 'details-client-cell', rowStyle, detailsStyle, detailsBorderStyle, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  });

}
